import React from 'react';

import { graphql, withApollo } from 'react-apollo';
import {
  Input,
  Tooltip,
  notification,
  Button,
  Modal,
  DatePicker,
} from 'antd/lib';
import { Form } from '@ant-design/compatible';
import * as Icons from '@ant-design/icons';

import moment from 'moment';
import confirmarTraspaso from '../../../../graphql/mutations/rrhh/confirmarTraspaso.graphql';
import getTraspasos from '../../../../graphql/querys/rrhh/getTraspasos.graphql';

const FormItem = Form.Item;
const { TextArea } = Input;

@graphql(confirmarTraspaso, {
  name: 'confirmarTraspaso',
  options: {
    refetchQueries: [{ query: getTraspasos }],
  },
})
class DatosRecepcion extends React.Component {
  onSubmit = e => {
    e.preventDefault();

    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        values.fechaReal = values.fechaReal.toDate();
        this.confirmarTraspaso(values);
      }
    });
  };

  confirmarTraspaso = valores => {
    // console.log("Estoy en el confirmar recepcion de traspaso");
    // console.log(valores);

    this.props
      .confirmarTraspaso({
        variables: {
          _id: this.props.traspaso._id,
          fechaReal: valores.fechaReal,
          observacionRecepcion: valores.observacionRecepcion
            ? valores.observacionRecepcion
            : '',
        },
      })
      // eslint-disable-next-line no-unused-vars
      .then(res => {
        notification.success({
          message: 'Recepcion guardada con exito',
          description: 'Se ha registrado los nuevos datos de la recepcion',
        });

        this.props.history.push('/rrhh/traspasos');
      })
      .catch(err => {
        console.log('Error en la confirmacion de la recepcion');
        console.log(err);

        Modal.error({
          title: 'Error en la confirmacion de la recepción',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    return (
      <div>
        <h1 className="tituloForm">Datos de Recepción</h1>
        <Form
          onSubmit={this.onSubmit}
          style={{ marginTop: 50, marginRight: 40 }}
        >
          <FormItem
            {...formItemLayout}
            label={
              <span>
                Fecha de recepcion
                <Tooltip title="Seleccione la fecha de que se recibió el organismo">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('fechaReal', {
              rules: [
                {
                  type: 'object',
                  required: true,
                  message: 'Por favor, seleccione la fecha de la recepcion',
                },
              ],
              // initialValue: moment(this.props.traspaso.fechaEstimada, "HH:mm")
            })(
              <DatePicker
                showTime={{
                  minuteStep: 10,
                  format: 'HH:mm',
                  defaultValue: moment('14:00:00', 'HH:mm:ss'),
                }}
                style={{ color: '#000000' }}
                format="DD-MM-YYYY HH:mm"
                placeholder="Seleccionar Fecha y Hora"
              />
            )}
          </FormItem>

          <FormItem
            {...formItemLayout}
            label={
              <span>
                Observación
                <Tooltip title="Si lo desea, puede agregar algun comentario de la recepcion">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('observacionRecepcion', {})(
              <TextArea style={{ color: '#000000' }} rows={6} />
            )}
          </FormItem>
          <FormItem {...tailFormItemLayout}>
            <Button
              type="primary"
              htmlType="submit"
              style={{ marginLeft: '25%' }}
            >
              Confirmar
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

export default Form.create({
  mapPropsToFields(props) {
    // console.log("Las que me llega es...");
    // console.log(props);
    // console.log(moment(props.traspaso.fechaEstimada).format("DD-MM-YYYY HH:mm"))
    return {
      fechaReal: Form.createFormField({
        value: props.traspaso ? moment(props.traspaso.fechaEstimada) : moment(),
      }),
      observacionRecepcion: Form.createFormField({
        value:
          props.traspaso && props.traspaso.observacionRecepcion
            ? props.traspaso.observacionRecepcion
            : '',
      }),
    };
  },
})(withApollo(DatosRecepcion));
